import React from 'react';
import { Plus } from 'lucide-react';

interface TextOptionalActionButtonProps {
  text: string;
  onClick: () => void;
  disabled?: boolean;
  actionName?: string;
  icon?: React.ReactNode;
  variant?: 'default' | 'blue';
}

const TextOptionalActionButton: React.FC<TextOptionalActionButtonProps> = ({ 
  text, 
  onClick, 
  disabled = false, 
  actionName,
  icon,
  variant = 'blue'
}) => {
  const baseClasses = "font-light transition duration-300 underline flex items-center space-x-2 text-xs";
  const variantClasses = variant === 'blue' 
    ? 'text-blue-600 hover:text-blue-700' 
    : 'text-gray-700 hover:text-gray-900';
  const disabledClasses = disabled ? 'cursor-default opacity-50' : 'cursor-pointer';
  
  // Use provided icon, default to Plus icon if not provided, or null if explicitly set to null
  const displayIcon = icon === undefined ? <Plus className="h-4 w-4" /> : icon;

  return (
    <button
      onClick={(e) => { 
        e.stopPropagation(); 
        if (!disabled) onClick(); 
      }} 
      disabled={disabled}
      className={`${baseClasses} ${variantClasses} ${disabledClasses}`}
      {...(actionName !== undefined && { 'data-dd-action-name': actionName })}
    >
      {displayIcon}
      <span>{text}</span>
    </button>
  );
};

export default TextOptionalActionButton;
